import React from "react";
import Table from '../../../../components/StatsTable';
import { NAN_PARAMS, PARAMS_NAME } from "../../../BidderNetworkPerformanceHourlyV2/config";

class AdContentTable extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { params = [], report = [], total = [] } = this.props.report || {};

        const paramsObj = params.reduce((obj, param, index) => ({ ...obj, [ param ]: index }), {});

        return (
            <div>
                <Table params={params} paramsObj={paramsObj} report={report} total={total} paramNames={{ ...PARAMS_NAME, adtitle: 'Ad Title', ctr: "CTR %", tonicRPC: "Tonic RPC", campaign_name: "Campaign Name", conversions: 'Tonic CNV', roi: 'ROI', percentRoi: 'ROI%', cpc: 'CPC', rpc: 'RPC', clicks: "Clicks", ...this.props.PARAMS_NAME }} NaNParams={{ ...NAN_PARAMS, adtitle: 1, campaign_name: 1, date: 1, network: 1, campaign: 1, site: 1, country: 1, keyword: 1 }}/>
            </div>
        )
    }
}


export default AdContentTable;


// WEBPACK FOOTER //
// ./src/scenes/AdContentArbitrage/components/AdContentTable/index.js